import React from 'react';
import { BarChart3Icon, BellIcon, Building2Icon, CalendarDaysIcon, ChevronLeftIcon, ConciergeBellIcon, SettingsIcon, SparklesIcon } from 'lucide-react';
const items = [{
  label: 'Overview',
  icon: BarChart3Icon,
  active: true
}, {
  label: 'Rates',
  icon: Building2Icon
}, {
  label: 'Demand',
  icon: CalendarDaysIcon
}, {
  label: 'VIP arrivals',
  icon: SparklesIcon,
  count: 2
}, {
  label: 'Alerts',
  icon: BellIcon,
  count: 4
}];
export function Sidebar() {
  return <aside className="hidden min-h-screen w-[232px] shrink-0 flex-col border-r border-white/10 bg-[#071827] text-[#f4efe4] lg:flex" data-id="element-130">
      <div className="flex h-20 items-center gap-3 border-b border-white/10 px-6" data-id="element-131">
        <span className="grid h-9 w-9 place-items-center border border-[#c6a86d]/50 text-[#d6bd87]" data-id="element-132">
          <ConciergeBellIcon size={18} strokeWidth={1.5} data-id="element-133" />
        </span>
        <div data-id="element-134">
          <p className="font-serif text-lg leading-none tracking-wide" data-id="element-135">
            Aurelian
          </p>
          <p className="mt-1 text-[9px] uppercase tracking-[0.24em] text-[#a8a69f]" data-id="element-136">
            Hotel Collection
          </p>
        </div>
      </div>
      <nav aria-label="Primary" className="flex-1 px-3 py-7" data-id="element-137">
        <p className="px-3 pb-3 text-[9px] font-semibold uppercase tracking-[0.2em] text-[#747d84]" data-id="element-138">
          Revenue desk
        </p>
        <ul className="space-y-1" data-id="element-139">
          {items.map(({
          label,
          icon: Icon,
          active,
          count
        }) => <li key={label} data-id="element-140">
              <button type="button" className={`group flex w-full items-center gap-3 border-l-2 px-3 py-2.5 text-left text-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#d6bd87] ${active ? 'border-[#d6bd87] bg-white/[0.06] text-white' : 'border-transparent text-[#aeb5b9] hover:bg-white/[0.04] hover:text-white'}`} data-id="element-141">
                <Icon size={17} strokeWidth={1.6} className={active ? 'text-[#d6bd87]' : ''} data-id="element-142" />
                <span className="flex-1" data-id="element-143">{label}</span>
                {count ? <span className="min-w-5 rounded-full bg-[#c6a86d] px-1.5 py-0.5 text-center text-[10px] font-bold text-[#071827]" data-id="element-144">
                    {count}
                  </span> : null}
              </button>
            </li>)}
        </ul>
      </nav>
      <div className="border-t border-white/10 p-3" data-id="element-145">
        <button type="button" className="flex w-full items-center gap-3 px-3 py-2.5 text-sm text-[#aeb5b9] hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#d6bd87]" data-id="element-146">
          <SettingsIcon size={17} strokeWidth={1.6} data-id="element-147" /> Settings
        </button>
        <button type="button" aria-label="Collapse sidebar" className="mt-2 flex w-full justify-end px-3 py-2 text-[#747d84] hover:text-white" data-id="element-148">
          <ChevronLeftIcon size={17} data-id="element-149" />
        </button>
      </div>
    </aside>;
}